import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Download } from 'lucide-react';
import { Button } from '../ui/button';

const DonationsTable = ({ donations, text, formatDate, formatAmount, onDownloadReceipt }) => {
  const navigate = useNavigate();

  if (donations.length === 0) {
    return (
      <div className="text-center py-12">
        <Heart className="w-16 h-16 text-[#E2E8F0] mx-auto mb-4" />
        <p className="text-[#546A76] mb-4">{text.noDonations}</p>
        <Button
          onClick={() => navigate('/donate')}
          className="gold-btn rounded-full"
        >
          {text.startDonating}
        </Button>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#E2E8F0]">
            <th className="text-left py-3 px-4 text-sm font-medium text-[#546A76]">{text.date}</th>
            <th className="text-left py-3 px-4 text-sm font-medium text-[#546A76]">{text.amount}</th>
            <th className="text-left py-3 px-4 text-sm font-medium text-[#546A76]">{text.type}</th>
            <th className="text-left py-3 px-4 text-sm font-medium text-[#546A76]">{text.status}</th>
            <th className="text-left py-3 px-4 text-sm font-medium text-[#546A76]">{text.receipts}</th>
          </tr>
        </thead>
        <tbody>
          {donations.map((donation) => (
            <tr key={donation.id} className="border-b border-[#F0F4F8]">
              <td className="py-4 px-4">{formatDate(donation.created_at)}</td>
              <td className="py-4 px-4 font-medium">{formatAmount(donation.amount)}</td>
              <td className="py-4 px-4">
                <span className={`px-2 py-1 rounded-full text-xs ${
                  donation.donation_type === 'monthly' 
                    ? 'bg-[#4A708B]/10 text-[#4A708B]'
                    : 'bg-[#D4AF37]/10 text-[#D4AF37]'
                }`}>
                  {donation.donation_type === 'monthly' ? text.monthly : text.single}
                </span>
              </td>
              <td className="py-4 px-4">
                <span className={`px-2 py-1 rounded-full text-xs ${
                  donation.payment_status === 'completed'
                    ? 'bg-green-100 text-green-700'
                    : 'bg-amber-100 text-amber-700'
                }`}>
                  {donation.payment_status === 'completed' ? text.completed : text.pending}
                </span>
              </td>
              <td className="py-4 px-4">
                {donation.receipt_generated && (
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onDownloadReceipt(donation.id)}
                    className="rounded-full text-xs"
                  >
                    <Download className="w-3 h-3 mr-1" />
                    PDF
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DonationsTable;
